<template>
  <div class="down-button" :class="{ safari: isSafari }" @click="$emit('click')">
    <slot />
  </div>
</template>

<script>
import { isSafari } from '$common/utils/common'

export default {
  data() {
    return {
      isSafari
    }
  }
}
</script>

<style lang="stylus" scoped>
  .down-button {
    position: relative;
    // width: 176px;
    width: 315px;
    height: 40px;
    text-align: center;
    position relative;
    padding: 4px 16px;
    // border: 1px solid #FFFFFF;
    // background: -webkit-linear-gradient(0deg, #ffc100 0%, #fc3700 100%);
    // background: -moz-linear-gradient(0deg, #ffc100 0%, #fc3700 100%);
    // background: -o-linear-gradient(0deg, #ffc100 0%, #fc3700 100%);
    // background: -ms-linear-gradient(0deg, #ffc100 0%, #fc3700 100%);
    // background: linear-gradient(90deg, #ffc100 0%, #fc3700 100%);
    margin: 0 auto;
    border-radius: 32px;
    color: #fff;
    font-size: 14px;
    font-family: Segoe UI;
    font-weight: 600;

    &.safari {
      &::after {
        // transform-origin: center center;
      }
    }

    &::after {
      position: absolute;
      left: 0;
      top: 0;
      content: '';
      width: 200%;
      height: 200%;
      transform: scale(0.5);
      border: 1px solid #ffffff;
      border-radius: 44px;
      transform-origin: left top;
    }
  }
</style>